export { default } from './HTMLVideoPlayer';



// WEBPACK FOOTER //
// ./src/components/atoms/HTMLVideoPlayer/index.js